import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {DataStorageHelper} from 'amc-common-components';
import {appAnimationTriggers} from './app.animation';

/**
 * App component.
 * @class
 */
@Component({
	selector: 'app-root-component',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [
		appAnimationTriggers.openCloseLeftPanel,
		appAnimationTriggers.openCloseDelimiter,
		appAnimationTriggers.openCloseRightPanel,
	],
})
export class AppComponent {

	/**
	 * Input variable for providing 'hide left panel' value to component from parent.
	 */
	@Input() readonly hideLeftPanel: boolean;

	/**
	 * Output variable for emitting 'toggle left panel' value from component to parent.
	 */
	@Output() readonly toggleLeftPanel = new EventEmitter<void>();

	/** Auxiliary 'DataStorageHelper' variable. */
	public readonly DataStorageHelper = DataStorageHelper;
}
